import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3437810515/src/pubgen-app/next-app/app/(authenticated)/[workspace]/client.tsx");
